<template>
  <div id="sde-developer-tool" class="px-2" v-if="isA1">
    <div class="settings-menu-padding">
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
          <feather-icon
            icon="ToolIcon"
            svg-classes="h-6 w-6 stroke-current text-white"
          />
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="10">
          <span class="sdf-text-16-700-white ml-4">デベロッパーツール</span>
        </vs-col>
      </vs-row>
    </div>

    <!--    <div class="settings-menu-padding">-->
    <!--      <vs-row vs-w="12">-->
    <!--        <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">-->
    <!--          <span-->
    <!--            class="sdf-text-16-400-white cursor-pointer"-->
    <!--            @click.stop="clickUpdateVesselInfo"-->
    <!--            >船舶情報の更新</span-->
    <!--          >-->
    <!--        </vs-col>-->
    <!--      </vs-row>-->
    <!--    </div>-->

    <div class="settings-menu-padding" v-if="isA1">
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="8">
          <span
            class="sdf-text-16-400-white cursor-pointer"
            @click.stop="clickManeuveringSimulator"
            >操船データシミュレーター</span
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
        </vs-col>
      </vs-row>
    </div>

    <div class="settings-menu-padding" v-if="isA1">
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="8">
          <span
            class="sdf-text-16-400-white cursor-pointer"
            @click.stop="showEventSimulatorDialog = !showEventSimulatorDialog"
            >イベントデータシミュレーター</span
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
        </vs-col>
      </vs-row>
    </div>

    <vs-prompt
      title="現在の船舶情報"
      accept-text="更新"
      cancel-text="キャンセル"
      @accept="updateVesselInfo"
      @cancel="cancelUpdateVesselInfo"
      @close="cancelUpdateVesselInfo"
      type="flat"
      :active.sync="showUpdateVesselInfoDialog"
      :color="sdfColor.Blue"
      :is-valid="isValidUpdateVesselInfo"
    >
      <div class="con-exemple-prompt">
        <label>パラメータ</label>
        <vs-input
          label="vessel_id"
          placeholder="10896"
          class="mt-2 mb-8"
          v-model="inputUpdateVesselInfoVesselId"
        />
        <vs-input
          label="handlingのorigin_id"
          placeholder="1"
          class="mt-2 mb-8"
          v-model="inputUpdateVesselInfoHandlingOriginId"
        />
        <vs-input
          label="engineのorigin_id"
          placeholder="2"
          class="mt-2 mb-8"
          v-model="inputUpdateVesselInfoEngineOriginId"
        />
        <div v-if="this.vesselInfo">
          <vs-divider :color="sdfColor.LightGray">
            現在のStoreの値
          </vs-divider>
          <pre>
          <code>
            {
                "vesselId": "{{this.vesselInfo.id}}",
                "maneuveringVersion": {
                    "id": "{{this.maneuveringVersion.id}}",
                    "name": "{{this.maneuveringVersion.name}}"
                },
                "engineVersion": {
                    "id": "{{this.engineVersion.id}}",
                    "name": "{{this.engineVersion.name}}"
                }
            }
          </code>
          </pre>
        </div>
      </div>
    </vs-prompt>

    <vs-prompt
      title="操船データシミュレーター"
      accept-text="シミュレーション開始"
      cancel-text="キャンセル"
      @accept="startManeuveringSimulator"
      :active.sync="showManeuveringSimulatorDialog"
      :color="sdfColor.Blue"
      :is-valid="isValidManeuveringSimulator"
    >
      <div class="con-exemple-prompt">
<!--        <label class="mt-2">シミュレートモード</label>-->
<!--        <ul id="maneuvering-simulator-mode-select" class="mt-2 mb-4">-->
<!--          <li>-->
<!--            <vs-radio v-model="maneuveringSimulatorMode" vs-value="normal"-->
<!--              >通常</vs-radio-->
<!--            >-->
<!--          </li>-->
<!--          <li>-->
<!--            <vs-radio v-model="maneuveringSimulatorMode" vs-value="berth"-->
<!--              >ゴースト</vs-radio-->
<!--            >-->
<!--          </li>-->
<!--        </ul>-->
        <label>再生インターバル 単位:ms</label>
        <vs-input
          class="mt-2 mb-8"
          v-model="maneuveringSimulatorIntervalTime"
        />
        <label class="mt-2 mb-2">操船データ</label>
        <div class="mt-2 mb-2">
          <vs-textarea v-model="maneuveringSimulatorTextarea" />
        </div>
        <span class="text-danger" v-show="error.message">{{
          error.message
        }}</span>
        <span class="text-success" v-show="success.message">{{
          success.message
        }}</span>
      </div>
    </vs-prompt>

    <vs-prompt
      title="イベントデータシミュレーター"
      accept-text="シミュレーション開始"
      cancel-text="キャンセル"
      @accept="startEventSimulator"
      :active.sync="showEventSimulatorDialog"
      :color="sdfColor.Blue"
      :is-valid="isValidEventSimulator"
    >
      <label class="mt-2 mb-2">イベントデータ</label>
      <div class="mt-2 mb-2">
        <vs-textarea v-model="eventSimulatorTextarea" />
      </div>
      <span class="text-danger" v-show="error.message">{{
        error.message
      }}</span>
      <span class="text-success" v-show="success.message">{{
        success.message
      }}</span>
    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import moment from "moment-timezone";

// mixins
import {
  ColorMixin,
  StoreCommonsMixin,
  StoreMenuMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

export default {
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  props: {},
  mixins: [
    ColorMixin,
    StoreCommonsMixin,
    StoreMenuMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  data() {
    return {
      intervalId: null,
      error: { message: null },
      success: { message: null },
      showUpdateVesselInfoDialog: false,
      inputUpdateVesselInfoVesselId: null,
      inputUpdateVesselInfoHandlingOriginId: null,
      inputUpdateVesselInfoEngineOriginId: null,
      textareaVesselInfo: null,
      tmpTextareaVesselInfo: null,
      showManeuveringSimulatorDialog: false,
      isValidManeuveringSimulator: false,
      maneuveringSimulatorTrackPositions: null,
      maneuveringSimulatorTextarea: null,
      maneuveringSimulatorMode: "normal",
      maneuveringSimulatorIntervalTime: 1000,
      showEventSimulatorDialog: false,
      isValidEventSimulator: false,
      eventSimulatorEvents: null,
      eventSimulatorTextarea: null,
      eventSimulatorIntervalId: null
    };
  },
  watch: {
    // textareaVesselInfo(val, oldVal) {
    //   if (val) {
    //     try {
    //       this.tmpTextareaVesselInfo = JSON.parse(val);
    //       this.isValidUpdateVesselInfo = true;
    //       this.error.message = null;
    //       this.success.message = "正しいフォーマットです";
    //     } catch (e) {
    //       this.isValidUpdateVesselInfo = false;
    //       this.error.message = "フォーマットが不正です";
    //       this.success.message = null;
    //     }
    //   } else {
    //     this.isValidUpdateVesselInfo = false;
    //     this.error.message = null;
    //   }
    // },
    maneuveringSimulatorTextarea(val, oldVal) {
      if (val) {
        try {
          this.maneuveringSimulatorTrackPositions = JSON.parse(val);

          // const after = this.maneuveringSimulatorTrackPositions.map((v, i) => {
          //   if (i < 30) {
          //     v.SB44.vs = "N";
          //   } else if (i >= 30 && i < 60) {
          //     v.SB44.vs = "K";
          //   } else if (i >= 60 && i < 140) {
          //     v.SB44.vs = "P";
          //   } else if (i >= 140) {
          //     v.SB44.vs = "B";
          //   }
          //   return v;
          // });
          // console.log(JSON.stringify(after));

          this.isValidManeuveringSimulator = true;
          this.error.message = null;
          this.success.message = "正しいフォーマットです";
        } catch (e) {
          this.isValidManeuveringSimulator = false;
          this.error.message = "フォーマットが不正です";
          this.success.message = null;
        }
      } else {
        this.isValidManeuveringSimulator = false;
        this.error.message = null;
      }
    },
    eventSimulatorTextarea(val, oldVal) {
      if (val) {
        try {
          this.eventSimulatorEvents = JSON.parse(val);
          this.isValidEventSimulator = true;
          this.error.message = null;
          this.success.message = "正しいフォーマットです";
        } catch (e) {
          this.isValidEventSimulator = false;
          this.error.message = "フォーマットが不正です";
          this.success.message = null;
        }
      } else {
        this.isValidEventSimulator = false;
        this.error.message = null;
      }
    }
  },
  computed: {
    isA1() {
      return this.$route.path.includes("monitoring-vessel-handling");
    },
    isValidUpdateVesselInfo() {
      return !!(
        this.inputUpdateVesselInfoVesselId &&
        this.inputUpdateVesselInfoHandlingOriginId &&
        this.inputUpdateVesselInfoEngineOriginId
      );
    }
  },
  methods: {
    clickUpdateVesselInfo() {
      this.showUpdateVesselInfoDialog = true;
    },
    cancelUpdateVesselInfo() {
      this.cleanupUpdateVesselInfo();
    },
    updateVesselInfo() {
      let payload = {
        vesselId: this.inputUpdateVesselInfoVesselId,
        params: {
          maneuvering: {
            origin_id: Number(this.inputUpdateVesselInfoHandlingOriginId),
            kind: "handling"
          },
          engine: {
            origin_id: Number(this.inputUpdateVesselInfoEngineOriginId),
            kind: "engine"
          }
        }
      };
      this.RELOAD_VESSEL_INFO(payload);
      this.cleanupUpdateVesselInfo();
    },
    cleanupUpdateVesselInfo() {
      this.inputUpdateVesselInfoVesselId = null;
      this.inputUpdateVesselInfoHandlingOriginId = null;
      this.inputUpdateVesselInfoEngineOriginId = null;
    },
    clickManeuveringSimulator() {
      this.showManeuveringSimulatorDialog = true;
    },
    startManeuveringSimulator() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.SET_IS_SHOW_MENU(false);
      this.RESET_GHOST_POSITIONS();
      this.RESET_TRACK_POSITIONS();
      this.SET_BERTH_MODE(this.maneuveringSimulatorMode === "berth");
      let startPoint = [
        this.maneuveringSimulatorTrackPositions[0].SB03.vn,
        this.maneuveringSimulatorTrackPositions[0].SB02.vn
      ];
      this.SET_JUMP_TO({
        center: startPoint,
        zoom: 14
      });
      this.SET_CHANNEL_DATA_MANEUVERING(
        this.maneuveringSimulatorTrackPositions[0]
      );
      let index = 0;
      let intervalTime =
        this.maneuveringSimulatorIntervalTime === ""
          ? 1000
          : this.maneuveringSimulatorIntervalTime;
      this.intervalId = this.$setInterval(() => {
        this.SET_CHANNEL_DATA_MANEUVERING(
          this.maneuveringSimulatorTrackPositions[index]
        );
        if (index === this.maneuveringSimulatorTrackPositions.length - 1) {
          clearInterval(this.intervalId);
        } else {
          index++;
        }
      }, intervalTime);
    },
    startEventSimulator() {
      if (this.eventSimulatorIntervalId) {
        clearInterval(this.eventSimulatorIntervalId);
        this.eventSimulatorIntervalId = null;
      }
      this.SET_IS_ARRIVED_POINT(false);
      this.SET_IS_SHOW_MENU(false);

      let index = 0;
      let eventSimulatorEvents = this.eventSimulatorEvents.slice();
      this.eventSimulatorIntervalId = this.$setInterval(() => {
        this.SET_EVENT_DATA(eventSimulatorEvents[index]);
        let latestDeparturePoint = null;
        let nextArrivalPoint = null;
        let veeringPointsInfo = JSON.parse(
          eventSimulatorEvents[index].data.veering_points_info
        );
        let actualTimeCount = 0;
        veeringPointsInfo.some(value => {
          if (typeof value.actual_time === "undefined") {
            nextArrivalPoint = value;
            this.SET_NEXT_ARRIVAL_POINT(nextArrivalPoint);
            return true;
          } else {
            actualTimeCount++;
            latestDeparturePoint = value;
            this.SET_LATEST_DEPARTURE_POINT(latestDeparturePoint);
            //着岸モード開始かどうかを判定 ＊到着航路の３つ手前から
            if (
              latestDeparturePoint.number ===
              eventSimulatorEvents.length - 4
            ) {
              this.SET_BERTH_MODE(true);
            }
          }
        });
        // actual_time
        if (actualTimeCount === this.eventSimulatorEvents.length) {
          this.SET_IS_ARRIVED_POINT(true);
        }
        if (index === this.eventSimulatorEvents.length - 1) {
          clearInterval(this.eventSimulatorIntervalId);
        } else {
          index++;
        }
      }, 1000);

      this.eventSimulatorTextarea = null;
      this.isValidEventSimulator = false;
      this.error.message = null;
      this.success.message = null;
    }
  }
};
</script>

<style lang="scss">
#sdf-developer-tool {
  .con-exemple-prompt {
    padding: 10px 10px 0;
    .vs-input--label {
      margin-top: 10px;
    }
    .vs-input {
      width: 100%;
      margin-top: 10px;
    }
    .wrapp {
      display: flex;
    }
  }
}

#maneuvering-simulator-mode-select {
  list-style: none;
  overflow: hidden;
}

#maneuvering-simulator-mode-select li {
  width: 80px;
  float: left;
}

pre {
  background-color: #eee;
}

code {
  background-color: #eee;
}
</style>
